import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <span className="text-red-500 text-[10px] font-medium px-2 py-1 rounded bg-red-50 border border-red-200">
          Invalid
        </span>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
